import React from "react";
//import ReactDOM from 'react-dom/client';
import "./styleHeader.css";
import logo from "./images/africanmoose-logo.png";

//const domNode = document.getElementById('navHeader');

// variables
//const NAV_HEADER = document.getElementById('navHeader');
//const NAV_FOOTER = document.getElementById('navFooter');


//const HOME_LINK = ""
//const HOME_LINK = "https://africanmoosedesign.netlify.app/";
//const HOME_LINK = "http://127.0.0.1:5500/";
//const ABOUT_LINK = "indexAbout.html";
//const CONTACT_LINK = "indexContact.html";
//const WORK_LINK = "indexWork.html"

const openInNewTab = url => {
      window.open(url, '_blank', 'noopener,noreferrer');
    };

//functions

// enlarge clickable elements slightly
//function enlargeElement(element) {
//    element.classList.add('emphasizeElement')
//}

// restore clickable elements as they were
//function restoreElement(element) {
//    element.classList.remove('emphasizeElement');
//}



function NavHeader() {
    return (
        <div>
            <div className="navHeader" id="navHeader">
                <div id="navHeaderHome" className="navHeaderHome" onClick={() => openInNewTab('https://africanmoosedesign.netlify.app/')}>
                    <img src={logo} alt="AfricanMoose Design" height="50">

                    </img>
                    <div className="navHeaderTitle">Financial Database</div>
                </div>
            </div>
        
        </div>
    );
  }





  export default NavHeader;
